import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import { messages } from '../messages';
import { useStyles } from './styles';

export const TurnBadges = ({
  thumbsDown,
  knowledgeGap,
}: {
  thumbsDown: boolean;
  knowledgeGap: boolean;
}) => {
  const classes = useStyles();
  const intl = useIntl();
  if (!thumbsDown && !knowledgeGap) return null;
  return (
    <div className={classes.badges}>
      {thumbsDown && (
        <span className={classNames(classes.badge, classes.thumbsDown)}>
          {intl.formatMessage(messages.filterThumbsDown)}
        </span>
      )}
      {knowledgeGap && (
        <span className={classNames(classes.badge, classes.knowledgeGap)}>
          {intl.formatMessage(messages.filterKnowledgeGap)}
        </span>
      )}
    </div>
  );
};
